// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"f9909c71","994":"396c33d9"}[chunkId] + ".chunk.js";
};